import React from "react";
import {
  FaLink,
  FaShieldAlt,
  FaUserCheck,
  FaLayerGroup,
  FaClipboardCheck,
  FaChartBar,
  FaTachometerAlt,
  FaUsers,
} from "react-icons/fa";

function ProjectVerification() {
  return (
    <>
      <div className="pricing-style-one-area default-padding bg-gray">
        <div className="container">
          <div className="site-heading text-center">
            <h4 className="sub-title">What we do</h4>
            <h2 className="title split-text-right split-text-in-right">
              Key Highlights of our Crypto Launchpad Development Service
            </h2>
            <p>
              Our team of Tezos blockchain experts is here to guide your journey
              in Web3 innovation. Partner with Xeer Technology to create
              scalable, secure, and community-driven applications on Tezos.
            </p>
          </div>
        </div>

        <div className="container">
          <div className="row">
            {/* LEFT COLUMN */}
            <div className="col-xl-6">
              <ul className="pricing-types ">
                <li>
                  <div className="one">
                    <FaLink size={40} />
                  </div>
                  <div className="info">
                    <h4>Multi-Chain Compatibility</h4>
                    <p>
                      Supports multiple blockchains (e.g., Ethereum, Binance
                      Smart Chain, Solana) to allow projects to launch tokens on
                      the network that best suits their needs.
                    </p>
                  </div>
                </li>

                <li>
                  <div className="one">
                    <FaShieldAlt size={40} />
                  </div>
                  <div className="info">
                    <h4>Secure Smart Contracts</h4>
                    <p>
                      Custom-built, audited smart contracts that ensure secure,
                      transparent, and automated token sales, fund allocation,
                      and distribution processes.
                    </p>
                  </div>
                </li>

                <li>
                  <div className="one">
                    <FaUserCheck size={40} />
                  </div>
                  <div className="info">
                    <h4>KYC/AML Compliance</h4>
                    <p>
                      Integrated KYC and AML checks to verify investor
                      identities and maintain regulatory compliance, fostering a
                      secure environment for all participants.
                    </p>
                  </div>
                </li>

                <li>
                  <div className="one">
                    <FaLayerGroup size={40} />
                  </div>
                  <div className="info">
                    <h4>Tiered Investment Levels</h4>
                    <p>
                      Allows for tier-based access to token sales, offering
                      different levels of investment options and perks based on
                      user participation and loyalty.
                    </p>
                  </div>
                </li>
              </ul>
            </div>

            {/* RIGHT COLUMN */}
            <div className="col-xl-6">
              <ul className="pricing-types fade-up-anim">
                <li>
                  <div className="one">
                    <FaClipboardCheck size={40} />
                  </div>
                  <div className="info">
                    <h4>Project Verification & Onboarding</h4>
                    <p>
                      Comprehensive onboarding tools for project teams,
                      including automated verification and due diligence to
                      maintain a high standard of quality for listed projects.
                    </p>
                  </div>
                </li>

                <li>
                  <div className="one">
                    <FaChartBar size={40} />
                  </div>
                  <div className="info">
                    <h4>Real-Time Analytics & Reporting</h4>
                    <p>
                      Detailed insights into platform performance, investor
                      engagement, and fundraising milestones, allowing both
                      admins and project teams to monitor success in real time.
                    </p>
                  </div>
                </li>

                <li>
                  <div className="one">
                    <FaTachometerAlt size={40} />
                  </div>
                  <div className="info">
                    <h4>User-Friendly Dashboard</h4>
                    <p>
                      An intuitive, all-in-one dashboard for investors and
                      project teams, simplifying navigation, token sale
                      participation, fund tracking, and project management.
                    </p>
                  </div>
                </li>

                <li>
                  <div className="one">
                    <FaUsers size={40} />
                  </div>
                  <div className="info">
                    <h4>Community Building & Marketing Support</h4>
                    <p>
                      Tools for building a strong community presence, including
                      whitelist management, promotional options, and integration
                      with social media channels to maximize engagement.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProjectVerification;
